import { Configuration, PopupRequest, PublicClientApplication } from "@azure/msal-browser";

// Set this to true for testing without Microsoft OAuth
const isTestMode = import.meta.env.VITE_TEST_MODE === 'true';

// Mock MSAL for testing (redirect flow: loginRedirect + handleRedirectPromise)
const mockMsalInstance = {
  loginRedirect: async () => {},
  loginPopup: async () => Promise.resolve({
    accessToken: 'test-microsoft-token',
    account: { username: 'test@example.com', name: 'Test User' }
  }),
  handleRedirectPromise: async () => null,
  logoutRedirect: async () => {},
  logoutPopup: async () => {},
  getAllAccounts: () => [],
  setActiveAccount: () => {},
  getActiveAccount: () => null
};

// Declare the variables first
let msalInstance: any;
let loginRequest: PopupRequest;

if (isTestMode) {
  msalInstance = mockMsalInstance;
  loginRequest = {
    scopes: ["User.Read", "email", "profile", "openid"]
  };
} else {
  // Validate required environment variables
  const requiredEnvVars = ['VITE_MICROSOFT_CLIENT_ID'];
  const missingEnvVars = requiredEnvVars.filter(varName => !import.meta.env[varName]);
  
  if (missingEnvVars.length > 0) {
    console.error('Missing Microsoft environment variables:', missingEnvVars);
    throw new Error(
      `Missing required Microsoft environment variables: ${missingEnvVars.join(', ')}\n` +
      'Please check your .env file and make sure all required variables are set.'
    );
  }

  const msalConfig: Configuration = {
    auth: {
      clientId: import.meta.env.VITE_MICROSOFT_CLIENT_ID,
      // "common" allows both work/school and personal Microsoft accounts (Hotmail, Outlook.com, Live)
      authority: "https://login.microsoftonline.com/common",
      redirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    }
  };

  loginRequest = {
    scopes: ["User.Read", "email", "profile", "openid"],
    prompt: "select_account", // Show account picker so user can choose which Microsoft account/email to use
  };

  try {
    // Initialize MSAL
    msalInstance = new PublicClientApplication(msalConfig);
    
    // Initialize the application (async, but we'll handle it in the service)
    msalInstance.initialize().then(() => {
      // MSAL initialized successfully
    }).catch((error: any) => {
      console.error('MSAL initialization error:', error);
      // Don't throw here, let the service handle it
    });
    
  } catch (error) {
    console.error('MSAL configuration error:', error);
    // Fallback to test mode if initialization fails
    msalInstance = mockMsalInstance;
  }
}

export { msalInstance, loginRequest };


